import { FC, memo } from 'react'
import { Modal } from '@jisr-hr/design-system'
import { Typography } from '@jisr-hr/ds'
import i18n from 'translations/i18n'
// import mainStyles from 'containers/authorised/setting/v2/payroll/PaymentProcess/payment.module.css'
// import { ReactComponent as InfoIcon } from 'assets/images/info_icon_black.svg'
import PaymentMethodsConfigList from './PaymentMethodsConfigList'
import { usePaymentMethod } from '../../components/usePaymentMethods'

const PaymentMethodSetup: FC = () => {
  const paymentCtx = usePaymentMethod()
  const { setupModalOpen } = paymentCtx
  return (
    <Modal
      isOpen={setupModalOpen}
      onClose={(): Promise<void> => paymentCtx.handleSetupMethodOpen(null)}
      variant="centerDialog"
      width={770}
      modalHeaderStyle={{ background: '#fff', padding: '24px 16px 16px', minHeight: 'auto' }}
      header={
        <Typography
          variant="subtitle-1"
          style={{ lineHeight: '20px', color: 'var(--color-base-colors-grey-1000)' }}
          text={i18n.t('select_payment_method')}
        />
      }
    >
      <div style={{ padding: 24 }}>
        {/* <Flex
          itemsCenter
          style={{ gap: 8 }}
          className={mainStyles.warning_alert_box}
        >
          <InfoIcon style={{ width: 20, height: 20 }} />
          <Typography
            variant="interface/default/sm"
            color="#14171F"
            style={{ lineHeight: '20px' }}
          >
            {i18n.t('payment_methods_setup_warning_note')}
          </Text>
        </Flex> */}

        <PaymentMethodsConfigList />
      </div>
    </Modal>
  )
}

export default memo(PaymentMethodSetup)
